var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgWtStamp = function SvgWtStamp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 158.76 163.15"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "WTStamp_svg__mask",
    x: 80.56,
    y: 0,
    width: 1.12,
    height: 8.24,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -.85)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "WTStamp_svg__mask-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "WTStamp_svg__path-3",
    className: "WTStamp_svg__stamp-1",
    d: "M80.56.85h1.13v8.24h-1.13V.85z"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "WTStamp_svg__mask-2",
    x: 141.47,
    y: 33.49,
    width: 17.29,
    height: 48.24,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -.85)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "WTStamp_svg__mask-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "WTStamp_svg__path-5",
    className: "WTStamp_svg__stamp-1",
    d: "M141.47 34.34h17.29v48.24h-17.29V34.34z"
  })))), /*#__PURE__*/React.createElement("style", null, ".WTStamp_svg__stamp-1,.WTStamp_svg__stamp-2{fill:#fff;fill-rule:evenodd}.WTStamp_svg__stamp-2{fill:#00243f}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "WTStamp_svg__Logo_WTStamp"
  }, /*#__PURE__*/React.createElement("path", {
    id: "WTStamp_svg__Fill-1",
    className: "WTStamp_svg__stamp-2",
    d: "M4.03 92.27l.63 4.37-3.21.5-.7-4.91-.75.11.83 5.81L9 96.89l-.13-.9-3.46.54-.63-4.38-.75.12z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "WTStamp_svg__Fill-2",
    className: "WTStamp_svg__stamp-2",
    d: "M7.1 82.18l.16 4.87-2.91.1-.13-4.19-.71.02.14 4.19-2.78.1-.16-4.7-.71.03.18 5.55L8 87.88l-.18-5.73-.72.03z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "WTStamp_svg__Fill-3",
    className: "WTStamp_svg__stamp-2",
    d: "M0 78.5l8.5.65.5-5.52-.78-.06-.42 4.7-3.16-.24.37-4.04-.77-.06-.36 4.04-3.03-.23.41-4.53-.77-.06L0 78.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "WTStamp_svg__Fill-4",
    className: "WTStamp_svg__stamp-2",
    d: "M1 69.42l.17-.93 7.22 1.57.88-4.91.73.16-1.05 5.84L1 69.42z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "WTStamp_svg__Group-67"
  }, /*#__PURE__*/React.createElement("path", {
    id: "WTStamp_svg__Fill-5",
    className: "WTStamp_svg__stamp-2",
    d: "M10 52.69l.3-.77 2.93 1.14a3.94 3.94 0 01.22 1.55 5 5 0 01-.35 1.64 4.59 4.59 0 01-1.31 1.88 4.05 4.05 0 01-2 .9 4.14 4.14 0 01-2.21-.26 4.14 4.14 0 01-1.79-1.3 4 4 0 01-.83-2 4.45 4.45 0 01.34-2.27 4.5 4.5 0 01.91-1.5 3.3 3.3 0 011.31-.92l.31.71a3.39 3.39 0 00-1.8 2 3.69 3.69 0 00-.24 1.84 3.17 3.17 0 00.68 1.62A3.28 3.28 0 007.93 58a3.27 3.27 0 001.79.21 3.31 3.31 0 001.59-.73 3.9 3.9 0 001.26-3.75z",
    transform: "translate(0 -.85)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "WTStamp_svg__Fill-7",
    className: "WTStamp_svg__stamp-2",
    d: "M17.19 45.11a3.22 3.22 0 00-.46-1.68 3.65 3.65 0 00-3.05-1.71 3.33 3.33 0 00-1.68.48 3.61 3.61 0 00-1.25 1.32 3.79 3.79 0 00-.48 1.76 3.23 3.23 0 00.47 1.72A3.4 3.4 0 0012 48.22a3.44 3.44 0 001.74.46 3.25 3.25 0 001.68-.49 3.64 3.64 0 001.25-1.33 3.5 3.5 0 00.48-1.75m-1.37 3.8a3.94 3.94 0 01-2.06.62 4.25 4.25 0 01-2.1-.53A4.13 4.13 0 0110 47.43a3.87 3.87 0 01-.55-2.09 4.57 4.57 0 01.61-2.2 4.41 4.41 0 011.55-1.65 4 4 0 012.07-.62 4.16 4.16 0 012.14.56A4.23 4.23 0 0117.45 43a4.13 4.13 0 01.55 2.06 4.52 4.52 0 01-.61 2.18 4.44 4.44 0 01-1.57 1.67",
    transform: "translate(0 -.85)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "WTStamp_svg__Fill-9",
    className: "WTStamp_svg__stamp-2",
    d: "M23.42 36.14a3.16 3.16 0 00-.21-1.72A3.39 3.39 0 0022.1 33a3.45 3.45 0 00-1.66-.71 3.17 3.17 0 00-1.72.23 3.53 3.53 0 00-1.43 1.13 3.62 3.62 0 00-.73 1.67 3.19 3.19 0 00.21 1.73 3.42 3.42 0 001.11 1.43 3.34 3.34 0 001.66.7 3.21 3.21 0 001.73-.24 3.62 3.62 0 001.43-1.13 3.54 3.54 0 00.72-1.67m-1.89 3.57a4.06 4.06 0 01-4.17-.55A4.24 4.24 0 0116 37.41a4 4 0 01-.24-2.14 4.41 4.41 0 01.92-2.09 4.52 4.52 0 011.77-1.42 3.92 3.92 0 012.13-.31 4.17 4.17 0 012.05.86 4.09 4.09 0 011.6 3.9 4.42 4.42 0 01-.92 2.07 4.52 4.52 0 01-1.78 1.43",
    transform: "translate(0 -.85)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "WTStamp_svg__Fill-11",
    className: "WTStamp_svg__stamp-2",
    d: "M29.68 29.87a4.05 4.05 0 001.06-1.63 3.1 3.1 0 00.07-1.73A3.66 3.66 0 0028.38 24a3 3 0 00-1.73 0 4 4 0 00-1.66 1l-1.74 1.7 4.69 4.82zm-7.58-3.05l2.4-2.34a4.9 4.9 0 012-1.24 3.86 3.86 0 012.13 0 4 4 0 011.89 1.14 4.07 4.07 0 011.09 1.91 3.87 3.87 0 01-.09 2.13 4.81 4.81 0 01-1.29 2l-2.4 2.34z",
    transform: "translate(0 -.85)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "WTStamp_svg__Fill-13",
    className: "WTStamp_svg__stamp-2",
    d: "M43.4 18.28l.42.63-4.85 3.23-4.56-6.86 4.7-3.13.42.63-3.98 2.65 1.63 2.43 3.54-2.35.41.61-3.54 2.36 1.69 2.54 4.12-2.74z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "WTStamp_svg__Fill-15",
    className: "WTStamp_svg__stamp-2",
    d: "M50.92 15.14l-4.01-2.02-.71 4.43-.89.46.86-5.2-4.42-2.23.89-.45L46.37 12l.68-4.12.83-.43-.79 4.87 4.74 2.36-.91.46z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "WTStamp_svg__Fill-17",
    className: "WTStamp_svg__stamp-2",
    d: "M57.17 9.31a1.84 1.84 0 00.08-1.64 1.88 1.88 0 00-1.14-1.22 2.92 2.92 0 00-1.94.15l-2.05.76 1.43 3.86 2.05-.76a2.89 2.89 0 001.57-1.15m-.66-3.58a2.6 2.6 0 011.56 1.64 2.53 2.53 0 01-.13 2.24 3.71 3.71 0 01-2.06 1.56l-2.07.76.9 2.44-.82.3L51 7l2.89-1.07a3.77 3.77 0 012.58-.15",
    transform: "translate(0 -.85)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "WTStamp_svg__Fill-19",
    className: "WTStamp_svg__stamp-2",
    d: "M68.17 8.76l.17.73-5.66 1.34-1.9-8.01 5.49-1.3.18.73-4.65 1.1.68 2.85 4.14-.98.17.72-4.14.98.7 2.98 4.82-1.14z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "WTStamp_svg__Fill-21",
    className: "WTStamp_svg__stamp-2",
    d: "M75.75 5.44a1.88 1.88 0 00.48-1.58 1.85 1.85 0 00-.81-1.45 2.86 2.86 0 00-1.92-.33l-2.17.24.45 4.1L74 6.18a2.78 2.78 0 001.8-.74zm1.12 3.79l-2.16-2.42c-.21.05-.43.08-.65.11l-2.2.24.29 2.59-.87.1-.9-8.18 3.06-.34a3.66 3.66 0 012.56.48 2.55 2.55 0 011.12 2 2.72 2.72 0 01-.31 1.67 2.74 2.74 0 01-1.28 1.1l2.31 2.59z",
    transform: "translate(0 -.85)"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#WTStamp_svg__mask)",
    id: "WTStamp_svg__Group-25"
  }, /*#__PURE__*/React.createElement("path", {
    id: "WTStamp_svg__Fill-23",
    className: "WTStamp_svg__stamp-2",
    d: "M80.62.01l.87-.01.14 8.23-.87.01-.14-8.23z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "WTStamp_svg__Fill-26",
    className: "WTStamp_svg__stamp-2",
    d: "M91.18 7.9l-.06.75-5.8-.41.59-8.21 5.63.4-.05.75-4.77-.34-.21 2.92 4.25.31-.05.73-4.25-.3-.22 3.05 4.94.35z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "WTStamp_svg__Fill-28",
    className: "WTStamp_svg__stamp-2",
    d: "M102.46 2.35l-1.64 8.07-.71-.14-3.85-7.61-1.33 6.55-.85-.18L95.72.98l.7.14 3.87 7.61 1.33-6.55.84.17z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "WTStamp_svg__Fill-30",
    className: "WTStamp_svg__stamp-2",
    d: "M105.75 12.27a4 4 0 01-1-1.92 4.2 4.2 0 01.25-2.21 4.3 4.3 0 011.24-1.85 3.9 3.9 0 012-.9 4.56 4.56 0 012.27.21 4.69 4.69 0 011.5.85 3.6 3.6 0 011 1.28l-.71.34a3.28 3.28 0 00-2-1.73 3.67 3.67 0 00-1.82-.16 3.35 3.35 0 00-1.58.74 3.54 3.54 0 00-1.15 3.29 3.29 3.29 0 00.78 1.57 3.67 3.67 0 001.53 1 3.24 3.24 0 002.63-.14l.34.71a3.57 3.57 0 01-1.55.41 4.72 4.72 0 01-3.61-1.5",
    transform: "translate(0 -.85)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "WTStamp_svg__Fill-32",
    className: "WTStamp_svg__stamp-2",
    d: "M118.64 16.63l-.33.67-5.22-2.57 3.63-7.39 5.07 2.5-.34.68-4.28-2.12-1.29 2.63 3.82 1.88-.33.67-3.82-1.88-1.35 2.74 4.44 2.19z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "WTStamp_svg__Fill-34",
    className: "WTStamp_svg__stamp-2",
    d: "M121.46 19.77a3.25 3.25 0 01-.68-1.35l.65-.38a3.21 3.21 0 00.61 1.25 4.26 4.26 0 001.14 1.06 2.84 2.84 0 001.61.56 1.28 1.28 0 001-.59 1.1 1.1 0 00.17-.83 2 2 0 00-.37-.77c-.19-.25-.47-.56-.83-.95a14.59 14.59 0 01-1-1.18 2.48 2.48 0 01-.43-1.08 1.79 1.79 0 01.32-1.23 2 2 0 01.89-.77 2.21 2.21 0 011.3-.14 4 4 0 011.59.66 5.05 5.05 0 011 .91 4.06 4.06 0 01.7 1.08l-.63.43a3.82 3.82 0 00-.65-1 4 4 0 00-.88-.77 2.61 2.61 0 00-1.59-.53 1.28 1.28 0 00-1 .61 1.06 1.06 0 00-.18.83 2.06 2.06 0 00.38.79c.2.25.48.57.84.95a10.31 10.31 0 011 1.17 2.31 2.31 0 01.44 1.06 1.73 1.73 0 01-.32 1.21 2 2 0 01-.89.78 2.26 2.26 0 01-1.31.12 4.19 4.19 0 01-1.6-.67 5.18 5.18 0 01-1.31-1.2",
    transform: "translate(0 -.85)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "WTStamp_svg__Fill-36",
    className: "WTStamp_svg__stamp-2",
    d: "M96.12 153.36l1.17 8.58-.87.12-.93-6.87-2.59 6.24-.43.05-4.15-5.27.93 6.82-.87.12-1.17-8.58.75-.1 4.59 5.85 2.83-6.86.74-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "WTStamp_svg__Fill-38",
    className: "WTStamp_svg__stamp-2",
    d: "M106.08 157.27l-3.32-3.87-.67 5zm.53.61l-4.61 1.38-.33 2.51-.92.27 1.33-9.43.87-.25 6.26 7.17-.93.28z",
    transform: "translate(0 -.85)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "WTStamp_svg__Fill-40",
    className: "WTStamp_svg__stamp-2",
    d: "M108.83 149.47l.84-.37 3.15 7.21 4.44-1.94.32.72-5.28 2.31-3.47-7.93z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "WTStamp_svg__Fill-42",
    className: "WTStamp_svg__stamp-2",
    d: "M116.21 146.01l.79-.45 3.94 6.8 4.2-2.42.39.68-4.98 2.89-4.34-7.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "WTStamp_svg__Fill-44",
    className: "WTStamp_svg__stamp-2",
    d: "M132 145.26a3.23 3.23 0 00.25-1.81 3.61 3.61 0 00-.74-1.75 3.81 3.81 0 00-1.49-1.17 3.44 3.44 0 00-1.82-.23 4 4 0 00-3 2.27 3.34 3.34 0 00-.25 1.82 3.49 3.49 0 00.74 1.74 3.57 3.57 0 001.49 1.17 3.47 3.47 0 001.83.22 3.82 3.82 0 001.76-.76 3.77 3.77 0 001.18-1.5m-2.89 3.11a4.19 4.19 0 01-2.25-.26 4.38 4.38 0 01-1.84-1.43 4.26 4.26 0 01-.9-2.14 4.17 4.17 0 01.33-2.25 4.72 4.72 0 011.5-1.87 4.66 4.66 0 012.19-1 4.23 4.23 0 012.25.26 4.35 4.35 0 011.84 1.42 4.43 4.43 0 01.91 2.16 4.32 4.32 0 01-.33 2.24 4.76 4.76 0 01-1.5 1.86 4.67 4.67 0 01-2.2 1",
    transform: "translate(0 -.85)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "WTStamp_svg__Fill-46",
    className: "WTStamp_svg__stamp-2",
    d: "M138.55 135.23a2 2 0 00-.67-1.6 2 2 0 00-1.63-.64 3 3 0 00-1.77 1l-1.61 1.65 3.11 3 1.6-1.64a3 3 0 001-1.81zm3.44 2.34l-3.37-.53c-.14.18-.3.35-.46.52l-1.63 1.67 2 1.92-.64.65-6.2-6.05 2.27-2.32a3.89 3.89 0 012.38-1.3 2.68 2.68 0 012.21.85 2.74 2.74 0 01.87 1.56 2.83 2.83 0 01-.3 1.75l3.6.56z",
    transform: "translate(0 -.85)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "WTStamp_svg__Fill-48",
    className: "WTStamp_svg__stamp-2",
    d: "M145.7 132.34a4.18 4.18 0 01-2.23.35 4.64 4.64 0 01-3.62-2.7 4.17 4.17 0 01-.29-2.24 4.78 4.78 0 01.93-2.21 4.93 4.93 0 011.32-1.23 3.73 3.73 0 011.59-.55l.12.81a3.43 3.43 0 00-2.36 1.44 3.81 3.81 0 00-.74 1.78 3.41 3.41 0 00.25 1.82 3.51 3.51 0 001.18 1.48 3.51 3.51 0 003.57.43 3.8 3.8 0 001.49-1.22 3.39 3.39 0 00.7-2.67l.81-.12a3.69 3.69 0 01-.07 1.68 4.85 4.85 0 01-.8 1.63 4.79 4.79 0 01-1.85 1.52",
    transform: "translate(0 -.85)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "WTStamp_svg__Fill-50",
    className: "WTStamp_svg__stamp-2",
    d: "M151.18 119.14l-5.07-.46 3 4.09zm.81.07l-2.35 4.21 1.51 2-.47.83-5.62-7.69.44-.78 9.49.77-.47.84z",
    transform: "translate(0 -.85)"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#WTStamp_svg__mask-2)",
    id: "WTStamp_svg__Group-54"
  }, /*#__PURE__*/React.createElement("path", {
    id: "WTStamp_svg__Fill-52",
    className: "WTStamp_svg__stamp-2",
    d: "M158.76 82.58h-.59a76.09 76.09 0 00-16.7-47.87l.47-.37a76.72 76.72 0 0116.82 48.24",
    transform: "translate(0 -.85)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "WTStamp_svg__Fill-55",
    className: "WTStamp_svg__stamp-2",
    d: "M66.57 158.76a77.14 77.14 0 01-54-40.16l.52-.27a76.58 76.58 0 0053.64 39.84z",
    transform: "translate(0 -.85)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "WTStamp_svg__Fill-57",
    className: "WTStamp_svg__stamp-2",
    d: "M87.83 79.15v-.96zm0-23.29v.5-.49zm10.08 11.56a12.08 12.08 0 01-10-11.77h-.21c-.45 9.43-8.45 11.77-10 11.77v.16c1.53 0 8.29 3.69 10 11.78h.21c1.69-8.09 8.45-11.78 10-11.78v-.16z",
    transform: "translate(0 -.85)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "WTStamp_svg__Fill-59",
    className: "WTStamp_svg__stamp-2",
    d: "M58.76 93.4L52 74.41a11.23 11.23 0 01-.75-3.41 3.92 3.92 0 012.15-3.51v-.12H36.18v.12c2 1.48 2.89 3.14 4.18 6.77L54 111h.31l5.29-15.2z",
    transform: "translate(0 -.85)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "WTStamp_svg__Fill-61",
    className: "WTStamp_svg__stamp-2",
    d: "M77.4 91l-5.18-16.59a10.61 10.61 0 01-.67-3.32 4.06 4.06 0 012.33-3.63v-.12h-17v.12c2 1.48 2.89 3.14 4.19 6.77l2 5.66 3.5 10.29L73.7 111h.3l5.11-14.53z",
    transform: "translate(0 -.85)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "WTStamp_svg__Fill-63",
    className: "WTStamp_svg__stamp-2",
    d: "M112.78 102V67.31h-11V102c0 3.93-.71 5.12-3.39 6.85v.11h17.73v-.11c-2.68-1.73-3.39-2.92-3.39-6.85",
    transform: "translate(0 -.85)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "WTStamp_svg__Fill-65",
    className: "WTStamp_svg__stamp-2",
    d: "M128.75 80.49l-1.54-13.73a10.66 10.66 0 01-4.17.53h-7.26v.16c3.42 0 10.71 5.57 12.84 13h.13z",
    transform: "translate(0 -.85)"
  })))));
};

export default SvgWtStamp;